import produce from "immer"
import { RrsCategory } from "server/models"

import { UNPUBLISHED } from "const"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initRrsCategory: RrsCategory = {
    id: null,
    originId: null,
    accountId: null,
    projectId: null,
    categoryId: null,
    name: "",
    shortName: "",
    description: "",
    order: null,
    customVariables: null,
    status: UNPUBLISHED,
}

const initRrsCategoryState: types.RrsCategoryState = {
    baseRoute: null,

    categoryList: {},
    categoryIds: [],
    categoryChildParent: {},
    categoryEdit: initRrsCategory,

    filters: {
        search: null,
    },

    // status change
    statusActive: null,

    // confirm delete
    active: null,
    showConfirmDelete: false,

    reloadList: true,
    reloadEdit: true,
}

const rrsCategoryReducer = produce((
    draft: types.RrsCategoryState = initRrsCategoryState,
    action: ActionTypes = null,
): types.RrsCategoryState => {
    switch (action.type) {
        case types.RRS_CATEGORY_BASE_ROUTE:
            draft.baseRoute = action.baseRoute
            return draft

        case types.RRS_CATEGORY_LIST:
            draft.categoryList = action.categoryList
            return draft

        case types.RRS_CATEGORY_IDS:
            draft.categoryIds = action.categoryIds
            return draft

        case types.RRS_CATEGORY_CHILD_PARENT:
            draft.categoryChildParent = action.childParent
            return draft

        case types.RRS_CATEGORY_EDIT:
            draft.categoryEdit = action.category
            return draft

        case types.RRS_CATEGORY_FILTERS:
            draft.filters = action.filters
            return draft


        // status change
        case types.RRS_CATEGORY_STATUS_ACTIVE:
            draft.statusActive = action.statusActive
            return draft


        // confirm delete
        case types.RRS_CATEGORY_ACTIVE:
            draft.active = action.active
            return draft

        case types.RRS_CATEGORY_SHOW_CONFIRM_DELETE:
            draft.showConfirmDelete = action.show
            return draft


        case types.RRS_CATEGORY_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.RRS_CATEGORY_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default rrsCategoryReducer
